"use client";

import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import * as React from "react";

type ThemeToggleProps = {
	ariaLabel?: string;
};

export function ThemeToggle({ ariaLabel = "Toggle theme" }: ThemeToggleProps) {
	const { theme, setTheme, resolvedTheme } = useTheme();
	const [mounted, setMounted] = React.useState(false);

	React.useEffect(() => {
		setMounted(true);
	}, []);

	if (!mounted) {
		return <div className="h-11 w-11" />;
	}

	const toggleTheme = () => {
		if (theme === "light") {
			setTheme("dark");
		} else if (theme === "dark") {
			setTheme("system");
		} else {
			setTheme("light");
		}
	};

	return (
		<button
			type="button"
			onClick={toggleTheme}
			className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-border/70 bg-card text-sm text-foreground transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
			aria-label={ariaLabel}
			title={`Current theme: ${theme} (resolved: ${resolvedTheme})`}
		>
			{theme === "system" ? (
				<Monitor className="h-4 w-4" />
			) : theme === "dark" ? (
				<Moon className="h-4 w-4" />
			) : (
				<Sun className="h-4 w-4" />
			)}
		</button>
	);
}
